import React, { useEffect, useMemo, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import { TabPanel, Tabs } from 'tea-component';
import { useIntl } from 'umi';

import './index.scss';
import Publications from './Publications';
import GameItem from '@op/components/GameItem';
import Hashtags from './Hashtags';
import SvgIcon from '@home/components/SvgIcon';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export default function HotContent({
  filter: oriFilter,
  onClear,
  selectedGameInfo,
}: any) {
  const { formatMessage } = useIntl();
  const [activeId, setActiveId] = useState('content');
  const [selectedHashtag, setSelectedHashtag] = useState('');

  const tabsHot = useMemo(
    () => [
      {
        id: 'content',
        label: formatMessage({
          id: 'Hot Content',
        }),
      },
      {
        id: 'hashtags',
        label: formatMessage({
          id: 'Hot Hashtags',
        }),
      },
    ],
    [formatMessage],
  );

  const onActive = (tabs: { id: string; label: string }) => {
    setActiveId(tabs.id);
    buriedBtnPoint('SwitchPublicationHashtag', { tab: tabs.label });
  };

  useEffect(() => {
    setSelectedHashtag('');
  }, [selectedGameInfo]);

  const selectedHashtagHeader = useMemo(() => {
    if (!selectedHashtag) {
      return <GameItem gameInfo={selectedGameInfo} />;
    }
    return (
      <div
        className="hashtag-header"
        onClick={() => {
          setSelectedHashtag('');
        }}
      >
        <SvgIcon type={'left-pointing'} className="hashtag-icon" />
        <span className="hashtag-text">{`#${selectedHashtag}`}</span>
      </div>
    );
  }, [selectedGameInfo, selectedHashtag]);

  const filter = useMemo(() => {
    const { channels, channel, ...restFilter } = oriFilter || {};
    return {
      channel: oriFilter?.channels || oriFilter?.channel,
      ...restFilter,
    };
  }, [oriFilter]);

  return (
    <CardCommon
      className="dbo-channel-hot-content-card"
      title={selectedHashtagHeader}
      hasDownload
      downloadIcon="clonse"
      downLoadTips={'Close'}
      handleDownloadOnClick={() => onClear()}
    >
      <div className="dbo-channel-hot-content-card-hd">
        <div
          className={`dbo-channel-hot-content-selected-hashtag ${
            selectedHashtag ? '' : '--hide'
          }`}
        >
          {selectedHashtag && (
            <Publications
              gameInfo={selectedGameInfo}
              filter={filter}
              selectedHashtag={selectedHashtag}
            />
          )}
        </div>
        <div
          className={`dbo-channel-hot-tabs ${selectedHashtag ? '--hide' : ''}`}
        >
          <Tabs
            tabs={tabsHot}
            animated={false}
            activeId={activeId}
            onActive={onActive}
            destroyInactiveTabPanel={false}
          >
            <TabPanel id="content">
              <Publications gameInfo={selectedGameInfo} filter={filter} />
            </TabPanel>
            <TabPanel id="hashtags">
              <Hashtags
                gameInfo={selectedGameInfo}
                filter={filter}
                setSelectedHashtag={setSelectedHashtag}
              />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </CardCommon>
  );
}
